const categoryTree = [
  {
    name: "Aliments et Laitiers",
    slug: "aliments-et-laitiers",
    children: [
      { name: "Produits laitiers", slug: "produits-laitiers", leaves: ["Produits laitiers", "Lait et Crème", "Ghee - beurre clarifié - samneh", "Beurre clarifié - Smen - Ghee", "Fromages libanais", "Yaourt et Labneh"] },
      { name: "Conserves", slug: "conserves", leaves: ["Conserves", "Produits congelés"] },
      { name: "Légumes Marinés", slug: "legumes-marines", leaves: ["Légumes Marinés"] },
      { name: "Olives", slug: "olives", leaves: ["Olives"] },
      { name: "Légumineuses et grains", slug: "legumineuses-grains", leaves: ["Légumineuses et grains", "Riz et vermicelles", "Boulghour", "Légumineuses", "Pâtes"] },
      { name: "Confitures", slug: "confitures", leaves: ["Confitures"] },
      { name: "Mélasses et miels", slug: "melasses-miels", leaves: ["Mélasses et miels"] },
      { name: "Viandes - Poissons", slug: "viandes-poissons", leaves: ["Viandes - Poissons", "Entrées-Mezzé"] },
    ],
  },
  {
    name: "Gourmandises",
    slug: "gourmandises",
    children: [
      { name: "Baklava", slug: "baklava", leaves: ["Baklava"] },
      { name: "Friandises", slug: "friandises", leaves: ["Friandises"] },
      { name: "Patisseries", slug: "patisseries", leaves: ["Patisserie Douaihy", "Patisseries", "Patisseries Douaihy"] },
      { name: "Halawa", slug: "halawa", leaves: ["Halawa"] },
      { name: "Gâteaux - Biscuits orientaux", slug: "gateaux-biscuits", leaves: ["Gâteaux - Biscuits orientaux"] },
    ],
  },
  {
    name: "Condiments",
    slug: "condiments",
    children: [
      { name: "Épices / Zaatar", slug: "epices-zaatar", leaves: ["Épices", "Epices", "Épice brute", "Zaatar"] },
      { name: "Concentrés", slug: "concentres", leaves: ["Concentrés"] },
      { name: "Huiles et vinaigres", slug: "huiles-vinaigres", leaves: ["Huiles et vinaigres"] },
      { name: "Ingrédients de pâtisserie", slug: "ingredients-patisserie", leaves: ["Ingrédients de pâtisserie"] },
      { name: "Tahini", slug: "tahini", leaves: ["Tahini", "Tomate"] },
    ],
  },
  {
    name: "Apéritifs et pain",
    slug: "aperitifs-pain",
    children: [
      { name: "Pain et Kaak", slug: "pain-kaak", leaves: ["pain et Kaak"] },
      { name: "Fruits à coques grillés", slug: "fruits-coques", leaves: ["Fruits à coques grillés"] },
      { name: "Fruits secs", slug: "fruits-secs", leaves: ["Fruits secs"] },
      { name: "Chips et apéritifs", slug: "chips-aperitifs", leaves: ["Chips et apéritifs"] },
    ],
  },
  {
    name: "Boissons",
    slug: "boissons",
    children: [
      { name: "Cafés", slug: "cafes", leaves: ["Cafés"] },
      { name: "Yerba Maté", slug: "yerba-mate", leaves: ["Yerba Maté"] },
      { name: "Infusions", slug: "infusions", leaves: ["Infusions"] },
      { name: "Jus - Sirops", slug: "jus-sirops", leaves: ["Jus", "Jus en poudre instantanée", "Jus - Sirops", "Sirops concentrés", "Grenade"] },
      { name: "Alcools", slug: "alcools", leaves: ["Arack ou Arak Libanais", "Bières"] },
      { name: "Thés", slug: "thes", leaves: ["Thés"] },
    ],
  },
  {
    name: "Autres",
    slug: "autres",
    children: [
      { name: "Autres", slug: "autres", leaves: ["Autres", "Savon d'Alep - Cosmétiques", "Accessoires", "Produits du monde"] },
    ],
  },
];

const leafSet = new Set();
const childByName = new Map();
const topByName = new Map();
const nodeBySlug = new Map();

categoryTree.forEach((top) => {
  topByName.set(top.name, top);
  nodeBySlug.set(top.slug, top);
  top.children.forEach((child) => {
    childByName.set(child.name, { child, parentTop: top });
    nodeBySlug.set(child.slug, child);
    child.leaves.forEach((leaf) => leafSet.add(leaf));
  });
});

function isKnownCategory(name) {
  return topByName.has(name) || childByName.has(name) || leafSet.has(name);
}

function getCategoryChildren(name) {
  if (topByName.has(name)) {
    const top = topByName.get(name);
    const result = [top.name];
    top.children.forEach((child) => {
      result.push(child.name, ...child.leaves);
    });
    return result;
  }

  if (childByName.has(name)) {
    const { child, parentTop } = childByName.get(name);
    if (child.leaves.length === 1 && child.leaves[0] === name) {
      return [name];
    }
    return [name, ...child.leaves, parentTop.name];
  }

  return [];
}

function getCategoryBySlug(slug) {
  return nodeBySlug.get(slug);
}

export { categoryTree, isKnownCategory, getCategoryChildren, getCategoryBySlug };
